export const BUTTON_ACTIONS = {
  none: {
    value: 'none',
    label: 'No Action',
    description: 'Button does nothing',
    requiresConfig: false
  },
  save: {
    value: 'save',
    label: 'Save Data',
    description: 'Save form data locally',
    requiresConfig: false
  },
  submit: {
    value: 'submit',
    label: 'Submit Form',
    description: 'Submit form data',
    requiresConfig: true,
    configFields: ['endpoint', 'method']
  },
  email: {
    value: 'email',
    label: 'Send Email',
    description: 'Trigger email send',
    requiresConfig: true,
    configFields: ['emailTo', 'subject', 'template']
  },
  route: {
    value: 'route',
    label: 'Navigate to Page',
    description: 'Navigate to another page',
    requiresConfig: true,
    configFields: ['route', 'openInNewTab']
  },
  download: {
    value: 'download',
    label: 'Download File',
    description: 'Download a file',
    requiresConfig: true,
    configFields: ['fileUrl', 'fileName']
  },
  api: {
    value: 'api',
    label: 'Call API',
    description: 'Make API request',
    requiresConfig: true,
    configFields: ['apiUrl', 'method', 'headers', 'body']
  },
  custom: {
    value: 'custom',
    label: 'Custom Action',
    description: 'Run custom JavaScript',
    requiresConfig: true,
    configFields: ['customScript']
  }
};

export const getButtonAction = (value) => BUTTON_ACTIONS[value];

export const getButtonActionsList = () => Object.values(BUTTON_ACTIONS);
